export default __webpack_public_path__ + "static/subscription-journey-collaboration-b6a0b0daa3f7930246c655ddb1f0c81a.svg";